export class ComponentModel {
    constructor(component) {
        const { name, uuid, keyword, botType } = component;
        this.name = name;
        this.uuid = uuid;
        this.key = keyword;
        this.botType = botType;
    }
}
